import React from 'react';

import type { LiveStreamingDto } from '@/application/interfaces/pegasus.gateway';

import LiveItem, { LiveStatus } from '../live-item/live-item';
import SimpleSlider from '../simple-slider';

type Props = {
  lives: LiveStreamingDto[];
};

const LivesSlider: React.FC<Props> = ({ lives }) => {
  return (
    <SimpleSlider>
      {lives.map(
        (live) =>
          live &&
          live.streaming.lessonStatus !== LiveStatus.LIVE && (
            <LiveItem key={live.guid} live={live} />
          ),
      )}
    </SimpleSlider>
  );
};

export default LivesSlider;
